import { translate } from '../../../common/helpers/translate.helper';
import { TableEmptyState } from '../../../common/TableEmptyState/TableEmptyState';

export const RecentActivitiesEmptyState = () => {
    return <TableEmptyState text={translate('dashboard.emptyList')} />;
};
